import axios from '../../common/api/axios';

export const getMrqs = async ({ projectId }) => {
  const response = await axios.get(`/mrq/manager/${projectId}`);
  console.log({ mrqs: response });
  return response.data;
};

export const getMrqData = async (id) => {
  const response = await axios.get(`/mrq/${id}`);
  return response.data;
};

export const getMrqPos = async (id) => {
  const response = await axios.get(`po/mrq/${id}`);
  return response.data;
};

export const getAllVouchers = async (to) => {
  const response = await axios.get(`/${to}`);
  return response.data;
};

export const addMaterialsTo = async ({ to, body }) => {
  const reqBody = {
    ...body,
    [`${to.toLowerCase()}Number`]: body.number,
    [`${to.toLowerCase()}Date`]: body.date,
  };

  console.log({ reqBody });
  const { data } = await axios.post(to, reqBody);
  return data;
};
